/**
 * Extends the global console with development-only methods
 * Adds console.logDev, console.errorDev, console.warnDev
 */

declare global {
  interface Console {
    logDev: (...args: any[]) => void;
    errorDev: (...args: any[]) => void;
    warnDev: (...args: any[]) => void;
  }
}

export default defineNuxtPlugin(() => {
  const isDevelopment = process.env.NODE_ENV === 'development' || import.meta?.env?.DEV;
  const noop = () => {};
  
  if (isDevelopment) {
    // Development: Active logging with [DEV] prefix
    console.logDev = (...args: any[]) => console.log('🔧 [DEV]', ...args);
    console.errorDev = (...args: any[]) => console.error('❌ [DEV]', ...args);
    console.warnDev = (...args: any[]) => console.warn('⚠️ [DEV]', ...args);
  } else {
    // Production: No-op functions (completely silent)
    console.logDev = noop;
    console.errorDev = noop;
    console.warnDev = noop;
  }
});